const formatter = new Intl.NumberFormat([], {
    style: 'currency',
    currency: 'BRL'
})


export default formatter
